import { render, staticRenderFns } from "./QAWarning.vue?vue&type=template&id=5980007e&"
import script from "./QAWarning.vue?vue&type=script&lang=js&"
export * from "./QAWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports